import React from 'react';
import { Main, Text } from 'styles/themeColors';
import { SPLIT_CONSIGNMENT } from 'constants/consignmentStates';
import FlexboxContainerComponent from 'components/UI/FlexboxContainer';
import Tooltip from 'components/UI/Tooltip';
import { ErrorRounded } from '@mui/icons-material';
import ConsignmentEntry from 'data/ConsignmentEntry';
import { TEXT_LABELS } from 'constants/productDetails';
import { TableColumn } from 'components/UI/TableAccessories';

export const getProductSkuValueField = (consignmentEntry: ConsignmentEntry, state: string, showLabel: boolean = true) => {
    return <FlexboxContainerComponent>
        {showLabel && <TableColumn color={consignmentEntry.materialApiValidation === false ? Main.error2 : Text.primary}>{TEXT_LABELS.SKU}</TableColumn>}
        <FlexboxContainerComponent flexDirection='row' alignItems='center' gap='4px'>
            <TableColumn
                color={consignmentEntry.materialApiValidation === false ? Main.error2 : Text.primary}
                width='auto !important'
                deleted={consignmentEntry.cancelQuantity > 0 && state !== SPLIT_CONSIGNMENT}
            >
                {consignmentEntry.productSKU ? consignmentEntry.productSKU : ''}
            </TableColumn>
            {
                consignmentEntry.materialApiValidation === false &&
                <Tooltip
                    content={TEXT_LABELS.MATERIAL_API_VALIDATION_FAILED}
                    key="materialApiValidation"
                    size="large"
                    direction='right'
                >
                    <ErrorRounded htmlColor={Main.error2} style={{ fontSize: 16, marginBottom: 4 }} />
                </Tooltip>
            }
        </FlexboxContainerComponent>
    </FlexboxContainerComponent>
}